<template>
  <fragment>
    <nav class="navbar navbar-expand-md app-header">
      <div class="container-fluid">
        <template v-if="!navHidden">
          <b-navbar-brand v-bind:[linkType]="homeLink">
            <svg-icon name="logo" />
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse">
            <div class="navbar-toggler-icon" />
          </b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>
            <ul class="navbar-nav main-nav mr-auto ml-auto">
              <template v-for="(route, index) in visibleRoutes">
                <router-link :key="`nav-item-link-${index}`"
                             tag="li"
                             class="nav-item main-nav-item"
                             :to="route.path"
                             :exact="route.path === '/'">
                  <a class="nav-link">
                    <svg-icon v-if="route.meta.icon" :name="route.meta.icon" />
                    {{ getDisplay(route) }}
                  </a>
                </router-link>
              </template>
            </ul>
            <div @click="toggleProfile"
                 class="profile-nav-button clickable"
                 :class="{'open': showProfile}"
                 v-if="user">
              <svg-icon class="icon-desktop" name="profile" />
              <svg-icon class="icon-mobile" name="profile-icon" />
              <span class="profile-nav-text">Profile</span>
            </div>
          </b-collapse>
        </template>
        <template v-else>
          <b-navbar-brand>
            <svg-icon name="logo" />
          </b-navbar-brand>

          <a class="nav-link button" @click="logout()">Log out</a>
        </template>
      </div>
    </nav>
  </fragment>
</template>

<script>
  import { routes } from "@/routes";
  import { createNamespacedHelpers } from 'vuex';
  const { mapGetters, mapMutations } = createNamespacedHelpers('user');

  import { clientRole, clientUserRole, clientProviderRole } from "@/constants";

  import jwtDecode from 'jwt-decode';

  export default {
    name: 'Header',
    data() {
      return {
        navHidden: false
      }
    },
    created() {
      let userAuth = jwtDecode(this.$auth.tokenData.accessToken);

      let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));

      this.navHidden = Boolean(userAuth.patient_info_hidden) || (loggedInUser && loggedInUser.roles.some(r => r === clientRole || r === clientUserRole || r === clientProviderRole));
    },
    computed: {
      ...mapGetters(["showProfile"]),

      isAuthenticated() {
        return this.$auth.isAuthenticated;
      },

      user() {
        return this.$auth.user;
      },

      linkType() {
        return process.env.VUE_APP_HOME_LINK_EXTERNAL === 'true' ? 'href' : 'to';
      },

      homeLink() {
        return process.env.VUE_APP_HOME_LINK;
      },

      visibleRoutes() {
        return routes.filter(route => {
          if (!(route.meta && route.meta.showInMenu)) return false;

          if (!route.meta.auth) return true;

          return this.$auth.isRouteAccessible(route);
        });
      }
    },
    methods: {
      ...mapMutations(["setShowProfile"]),
      
      async logout() {
        await this.$auth.logout("/");
      },

      toggleProfile() {
        this.setShowProfile(!this.showProfile);
      },

      getDisplay(route) {
        if (typeof (route.display) === "function")
          return route.display(this.$auth.userInfo.roles);

        return route.display;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .button {
    cursor: pointer;
  }
</style>